export const projects = [
    {
        name:"La ferme de l'enfer",
        type:"web",
        description:"A websit for a farm",
        client:"Wagner",
        year:2021,
        logo:"lfdle.png",
        client_url:"https://lafermedelenfer.fr",
        url:"https://lafermedelenfer.fr",
    },
    {
        name:"T-Slam",
        description:"An application for basketball tournament",
        client:"BCFD",
        client_url:"https://www.bcfd.fr",
        year:2022,
    },
    {
        name:"Santoline",
        description:"A software in collaboration with Yves Dumond, for the prediction of forest fires",
        client:"SDIS",
        client_url:"https://www.sdis83.fr/internet/",
        year:2022,
    },
    {
        name:"HiBook",
        description:"A social mobile application, with NFC connection",
        year:2021,
        logo:"HiBook.png",
    },
    {
        name:"F!RE",
        description:"A mobile game for Android coded with flutter",
        year:2022,
        logo:"F!RE.png",
    },
    {
        name:"Wave Gravity",
        description:"A mobile game for Android coded with Godot Engine",
        year:2022,
        url:"https://eispri-stic.gitlab.io/tuto-godot-1-flappybird-rendus/Pages/FlappyBird_Thomas_Vate.html"
    },
    {
        name:"IGP Pro",
        description:"A bot who's playing to the game IGP",
        year:2022,
        logo:"igp.jpeg"
    },
];